export default "__VITE_ASSET__dcT8Zami__"